import React from "react";
import { Typography } from "@mui/material";

export default function Label(props) {
  const { controleId, comp, stateData: data } = props;
  const attStyle = comp?.styleCss?.textalign || "";
  const cssClass = `${attStyle ? "text-" + attStyle : ""} ${comp?.cssclass || ""} form-group`;

  const stylecode = {
    fontSize: "14px",
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 600,
    color: "#000000", 
  };


  const renderTextContent = () => {
    const lines = comp.text?.split("&lt;br&gt;") || [];
    const content = lines.map((item, idx) => (
      <React.Fragment key={idx}>
        {item}
        <br />
      </React.Fragment>
    ));

    if (comp.formIcons) {
      return (
        <div className="d-flex">
          <div>
            <span>
              <i className={`${comp.formIcons} p-1`} aria-hidden="true" />
            </span>
          </div>
          <div>{content}</div>
        </div>
      );
    }

    return <div>{content}</div>;
  };

  const resolvedContent = controleId !== "" ? data[controleId] : renderTextContent();

  const renderByType = (type) => {

    const commonSx = {
      fontSize: "14px",
      fontFamily: "Open Sans, sans-serif",
      fontWeight: 600,
      color: "#000000",
    };

    switch (type) {
      case "ol":
        return (
          <ol type={comp.orderedListType} style={commonSx}>
            {(comp.text?.split("&lt;br&gt;") || []).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        );
      case "ul":
        return (
          <ul style={commonSx}>
            {(comp.text?.split("&lt;br&gt;") || []).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        );
      case "paragraph":
        return <Typography variant="body1" sx={commonSx}>{resolvedContent}</Typography>;
      case "label":
        return <Typography variant="body2" sx={commonSx}>{resolvedContent}</Typography>;
      case "h1":
        return <Typography variant="h2" sx={{ fontSize: "1.625rem", fontWeight: "600", fontFamily: "Open Sans, sans-serif", color:"#000000" }}>{resolvedContent}</Typography>;
      case "h2":
        return <Typography variant="h3" sx={{ fontSize: "1.25rem", fontWeight: "600", fontFamily: "Open Sans, sans-serif", color:"#000000" }}>{resolvedContent}</Typography>;
      case "h3":
        return <Typography variant="h4" sx={{ fontSize: "1.0625rem", fontWeight: "600", fontFamily: "Open Sans, sans-serif", color:"#000000" }}>{resolvedContent}</Typography>;
      case "h4":
        return <Typography variant="h5" sx={{ fontSize: "0.9375rem", fontWeight: "600", fontFamily: "Open Sans, sans-serif", color:"#000000" }}>{resolvedContent}</Typography>;
      case "h5":
        return <Typography variant="h6" sx={{ fontSize: "0.875rem", fontWeight: "600", fontFamily: "Open Sans, sans-serif", color:"#000000" }}>{resolvedContent}</Typography>;
      default:
        return <Typography variant="body1" sx={commonSx}>{resolvedContent}</Typography>;
    }
  };

  return (
    <div className={cssClass}>
      {comp?.attributeDataTypes
        ? renderByType(comp.attributeDataTypes.type)
        : (
          <Typography variant="body1" sx={stylecode}>
            {resolvedContent}
          </Typography>
        )}
    </div>
  );
}
